"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCardExpirationMonths = exports.getCardExpirationYears = exports.getCardExpirationValues = exports.determineCreditCardType = exports.createPassthroughPaymentToken = exports.parsePassthroughPaymentToken = exports.maskCardNumber = void 0;
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const lodash_1 = require("lodash");
const types_1 = require("../types");
const base_64_utils_1 = require("./internal/base-64-utils");
const maskCardNumber = (cardNumber, options) => {
    const { firstN = 0, lastN = 4, length = 8 } = options || {};
    cardNumber = String(cardNumber);
    const start = (0, lodash_1.join)((0, lodash_1.take)(cardNumber, firstN), '');
    const end = (0, lodash_1.join)((0, lodash_1.takeRight)(cardNumber, lastN), '');
    return start + (0, lodash_1.padStart)(end, length - firstN, '*');
};
exports.maskCardNumber = maskCardNumber;
const parsePassthroughPaymentToken = (paymentToken) => {
    return (0, lodash_1.isEmpty)(paymentToken) ? {} : JSON.parse((0, base_64_utils_1.atob)(paymentToken));
};
exports.parsePassthroughPaymentToken = parsePassthroughPaymentToken;
const createPassthroughPaymentToken = (info) => {
    return (0, lodash_1.isEmpty)(info) ? undefined : (0, base_64_utils_1.btoa)(JSON.stringify(info));
};
exports.createPassthroughPaymentToken = createPassthroughPaymentToken;
const determineCreditCardType = (number) => {
    number = number.replace(/\D/g, '');
    if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(number)) {
        return types_1.CardType.VISA;
    }
    if (/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(number)) {
        return types_1.CardType.MASTERCARD;
    }
    if (/^3[47][0-9]{13}$/.test(number)) {
        return types_1.CardType.AMEX;
    }
    if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(number)) {
        return types_1.CardType.DISCOVER;
    }
    return undefined;
};
exports.determineCreditCardType = determineCreditCardType;
/**
 * Gets the month and year options for card expiration date selectors.
 * @returns The month and year options for card expiration date selectors.
 */
const getCardExpirationValues = () => {
    const years = (0, exports.getCardExpirationYears)();
    const months = (0, exports.getCardExpirationMonths)();
    return { months, years };
};
exports.getCardExpirationValues = getCardExpirationValues;
/**
 * Gets the year options for a card expiration date selector.
 * @returns The year options for a card expiration date selector.
 */
const getCardExpirationYears = () => {
    const currentYear = new Date().getUTCFullYear();
    const values = [];
    for (let year = currentYear; year < currentYear + 20; year++) {
        const label = (year + '').slice(-2);
        values.push({ label, value: year });
    }
    return values;
};
exports.getCardExpirationYears = getCardExpirationYears;
/**
 * Gets the month options for a card expiration date selector.
 * @returns The month options for a card expiration date selector.
 */
const getCardExpirationMonths = () => {
    return [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 }
    ];
};
exports.getCardExpirationMonths = getCardExpirationMonths;
//# sourceMappingURL=payment-utils.js.map